import {
  createReqConsts,
  createActions,
  createReqWatcher,
  makePaginationReducer,
} from '../../../utils/redux';
import { handleUpdateStatusSurveyInAppointmentDetails } from '../../../components/Healthboard/utils/handleUpdateStateWithCompleteSurvey';
import { handleUpdateStateWithAcceptedConsent } from '../../../components/Healthboard/utils/handleUpdateStateWithAcceptedConsent';
import { handleUpdateStateWithUploadDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithUploadDoc';
import { handleUpdateStateWithDeleteDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithDeleteDoc';
import { makeAppointmentListReqConfig } from './appointment-req-config';
import { consts as UPLOAD_DOCUMENT_CONST } from './upload-document-req';
import { consts as SURVEY_COMPLETIONS } from '../../surveys/upcoming-survey-completions';
import { consts as DELETE_DOCUMENT } from './delete-document-req';
import { consts as SIGN_CONSENT_APPOINTMENT } from './sign-appointment-consent-req';

const requestOptions = makeAppointmentListReqConfig([
  {
    type: 'payload.query',
    queryParameter: 'scope',
    value: 'history_list',
  },
]);

export const consts = createReqConsts(
  'health-board',
  'history-appointment-list-req',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'health-board',
  'history-appointment-list-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const reducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'appointmentsCount',
});

export default (state, action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT_CONST.SUCCEED: {
      return handleUpdateStateWithUploadDoc(state, action);
    }

    case SURVEY_COMPLETIONS.SUCCEED: {
      return handleUpdateStatusSurveyInAppointmentDetails(state, action);
    }

    case DELETE_DOCUMENT.UPDATE: {
      return handleUpdateStateWithDeleteDoc(state, action);
    }

    case SIGN_CONSENT_APPOINTMENT.SUCCEED: {
      return handleUpdateStateWithAcceptedConsent(state, action);
    }

    default:
      return reducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/appointments-history-req.js